import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = {
  key: 0,
  class: "flex space-x-1"
}
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = { class: "sr-only" }
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = { class: "sr-only" }
const _hoisted_8 = { class: "sr-only" }
const _hoisted_9 = { class: "sm:flex sm:justify-between" }
const _hoisted_10 = { class: "sm:flex" }
const _hoisted_11 = { class: "flex flex-1 items-center text-sm text-gray-500" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "flex flex-wrap"
}

import { PropType } from 'vue';
import { ConnectFlowModel, Permission } from '@/types';
import { applyPhoneMask } from '@/utils/number';
import { PhoneIcon } from '@heroicons/vue/solid';
import ConnectFlowIcon from '@/components/svg/ConnectFlowIcon';
import { ArchiveIcon, CheckCircleIcon, PencilAltIcon, XCircleIcon } from '@heroicons/vue/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectFlowListItem',
  props: {
    modelValue: {
        type: Object as PropType<ConnectFlowModel>,
        required: true,
    },
},
  emits: ['activate', 'inactivate'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const handleActivateClick = () => emit('activate', props.modelValue);
const handleInactivateClick = () => emit('inactivate', props.modelValue);

return (_ctx: any,_cache: any) => {
  const _component_UiIsActiveBadge = _resolveComponent("UiIsActiveBadge")!
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _component_UiAuditInfo = _resolveComponent("UiAuditInfo")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_UiPanel, { class: "space-y-2 hover:bg-white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_CONNECT_FLOW) ? 'RouterLink' : 'span'), {
            to: {
                        name: 'ViewConnectFlowById',
                        params: {
                            id: __props.modelValue.id,
                        },
                    },
            class: "text-md text-primary truncate font-medium"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.modelValue.name), 1)
            ]),
            _: 1
          }, 8, ["to"])),
          _createVNode(_component_UiIsActiveBadge, {
            "model-value": __props.modelValue,
            class: "ml-2 text-xs"
          }, null, 8, ["model-value"])
        ]),
        (_ctx.$can(_unref(Permission).EDIT_CONNECT_FLOW))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (__props.modelValue.isActive)
                ? _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                    key: 0,
                    variant: "danger",
                    onClick: handleInactivateClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('core.actions.Inactivate')), 1),
                      _createVNode(_unref(XCircleIcon), {
                        class: "h-6 w-6",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_tippy, _ctx.$t('core.actions.Inactivate')]
                  ])
                : _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                    key: 1,
                    variant: "success",
                    onClick: handleActivateClick
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('core.actions.Activate')), 1),
                      _createVNode(_unref(CheckCircleIcon), {
                        class: "h-6 w-6",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_tippy, _ctx.$t('core.actions.Activate')]
                  ]),
              _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                variant: "primary",
                to: {
                        name: 'EditConnectFlowById',
                        params: {
                            id: __props.modelValue.id,
                        },
                    }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('core.actions.Edit')), 1),
                  _createVNode(_unref(PencilAltIcon), {
                    class: "h-6 w-6",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_tippy, _ctx.$t('core.actions.Edit')]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                variant: "primary",
                to: {
                        name: 'EditFlowById',
                        params: {
                            id: __props.modelValue.id,
                        },
                    }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('connectFlow.actions.editFlow')), 1),
                  _createVNode(_unref(ConnectFlowIcon), {
                    class: "h-6 w-6",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_tippy, _ctx.$t('connectFlow.actions.editFlow')]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                variant: "primary",
                to: {
                        name: 'ViewConnectFlowHistoryById',
                        params: {
                            id: __props.modelValue.id,
                        },
                    }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('connectFlow.actions.history')), 1),
                  _createVNode(_unref(ArchiveIcon), {
                    class: "h-6 w-6",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_tippy, _ctx.$t('connectFlow.actions.history')]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(PhoneIcon), {
              class: "mr-1 h-5 w-5 flex-shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            (!__props.modelValue.numbers?.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('connectFlow.list.noNumbers')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue.numbers, (number, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: number.id
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$can(_unref(Permission).VIEW_NUMBER) ? 'RouterLink' : 'span'), {
                        to: {
                                    name: 'ViewNumberById',
                                    params: {
                                        id: number.id,
                                    },
                                },
                        class: _normalizeClass(["flex items-center text-sm text-gray-500", !_ctx.$can(_unref(Permission).VIEW_LEVEL) || 'text-primary font-medium'])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(applyPhoneMask)(number.number)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class"])),
                      _createTextVNode(" " + _toDisplayString(index != __props.modelValue.numbers.length - 1 ? ', ' : ''), 1)
                    ], 64))
                  }), 128))
                ]))
          ])
        ]),
        _createVNode(_component_UiAuditInfo, { "model-value": __props.modelValue }, null, 8, ["model-value"])
      ])
    ]),
    _: 1
  }))
}
}

})